import { z } from 'zod';

import { declareFetch } from './declarativeClient';

const $brazeSdkAuthToken = z.object({
    token: z.string(),
    expires_at: z.number()
});

/**
 * JSAD-7145. Fetches a short-lived signed token proving the caller owns the Braze
 * profile keyed to their OJS user id. The subject is taken from the session server
 * side, so this cannot be used to obtain a token for anyone else.
 *
 * Deliberately NOT on client.ts's BearerTokenBlacklist: it needs the session bearer.
 */
export const fetchBrazeSdkAuthToken = declareFetch<typeof $brazeSdkAuthToken>({
    path: 'v5/braze/sdk-auth-token',
    schema: $brazeSdkAuthToken
});

export default {
    fetchBrazeSdkAuthToken
};
